module.exports = __webpack_public_path__ + "media/images/bg/shapes/career/orange-7af615fc6aa14ad4b822590e7c56620f.svg";